import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative border-t border-white/10 bg-surface/40">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <Logo size="text-2xl" />
          <p className="mt-4 text-sm text-white/60 max-w-xs leading-relaxed">
            Cutting-edge AI apps, agents & websites — shipped in days, not months. Built lean, priced lean.
          </p>
        </div>

        <div className="text-sm">
          <h4 className="font-heading font-bold text-white mb-4 uppercase tracking-[0.2em] text-xs text-neon-cyan">
            Get in touch
          </h4>
          <p className="text-white/80 font-medium mb-2">Abhilash Reddy</p>
          <a
            href="tel:+19047891050"
            data-testid="footer-phone"
            className="flex items-center gap-2 text-white/60 hover:text-neon-cyan transition-colors mb-2"
          >
            <Phone size={15} /> +1 904-789-1050
          </a>
          <p className="flex items-center gap-2 text-white/60 mb-1">
            <MapPin size={15} /> Jacksonville, FL
          </p>
          <p className="flex items-center gap-2 text-white/60">
            <MapPin size={15} /> Hyderabad, India
          </p>
        </div>

        <div className="text-sm">
          <h4 className="font-heading font-bold text-white mb-4 uppercase tracking-[0.2em] text-xs text-neon-cyan">
            Selected work
          </h4>
          <a
            href="https://jananibachpan.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-link-janani"
            className="flex items-center gap-1 text-white/60 hover:text-neon-cyan transition-colors mb-2"
          >
            jananibachpan.com <ArrowUpRight size={14} />
          </a>
          <span className="block text-white/60 mb-2">ACE AI Apps</span>
          <Link
            to="/blog"
            data-testid="footer-blog-link"
            className="block text-white/60 hover:text-neon-cyan transition-colors mb-2"
          >
            Blog
          </Link>
          <Link
            to="/login"
            data-testid="footer-admin-link"
            className="inline-block mt-3 text-white/40 hover:text-neon-cyan text-xs transition-colors"
          >
            Admin Login
          </Link>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-white/40">
        © {new Date().getFullYear()} vonmal. Built fast. Built lean.
      </div>
    </footer>
  );
}
